module.exports = __webpack_public_path__ + "static/media/resume.ca669790.pdf";